var render = function render(){var _vm=this,_c=_vm._self._c;return _c('network-list',{attrs:{"getParams":_vm.getParams,"hidden-actions":['create'],"hidden-columns":['brand', 'region'],"hidden-filter-options":['brand', 'region', 'cloudaccount'],"id":"NetworkListForCloudregionSidePage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }